if ( typeof LocalizationForm !== 'function' ) {
	class LocalizationForm extends HTMLElement {

		constructor(){
      super();
      this.selector = this.querySelector('[data-js-localization-form-button]');
      this.content = this.querySelector('[data-js-localization-form-content]');
      if (!this.selector || !this.content) return;
      this.close = () => {
        this.content.classList.remove('content-opened','invert-x','invert-y');
        this.selector.setAttribute('aria-expanded','false');
        this.style.zIndex = '';
        window.removeEventListener('click',this.onOutsideClick);
      };
      this.onOutsideClick = event => { if (!this.contains(event.target)) this.close(); };
      this.selector.addEventListener('click',event => {
        event.preventDefault();event.stopPropagation();
        if (this.content.classList.contains('content-opened')) { this.close();return; }
        document.querySelectorAll('localization-form').forEach(other => { if(other !== this)other.close?.(); });
        if (this.querySelector('[data-js-localization-form-insert-helper-content]') && !this.classList.contains('populated')) {
          this.classList.add('populate');this.populate();
        }
        this.content.classList.add('content-opened');
        this.selector.setAttribute('aria-expanded','true');this.style.zIndex = '1000';
        if (this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight) this.content.classList.add('invert-y');
        if (this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth) this.content.classList.add('invert-x');
        window.addEventListener('click',this.onOutsideClick);
      });
      this.addEventListener('keydown',event => {
        if(event.key === 'Escape' && this.content.classList.contains('content-opened')) {
          event.preventDefault();this.close();this.selector.focus();
        }
      });
      this.addEventListener('click',event => {
        const option=event.target.closest('button[name="locale_code"],button[name="country_code"]');
        if(!option)return;
        const input=this.querySelector('input[type="hidden"][name="'+option.name+'"]');
        if(input)input.value=option.value;
      });
    }
    disconnectedCallback(){this.close?.();}

		populate() {
			fetch('?section_id=helper-localization-form').then(response=>response.text())
				.then(text => {
					const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-localization-form').innerHTML;
					this.querySelector('[data-js-localization-form-insert-helper-content]').innerHTML = results;
          this.classList.add('populated');
					if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
						this.content.classList.add('invert-y');
					}
					if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
						this.content.classList.add('invert-x');
					}
				})
				.catch(e=>{
					console.log(e);
				})
		}

	}

	if ( typeof customElements.get('localization-form') == 'undefined' ) {
		customElements.define('localization-form', LocalizationForm);
	}

}